import { Availability, FileReference, SiteObject } from "./baseEntities";

export interface Promotion extends BasePromotion, SiteObject {}

export interface BasePromotion {
  code: string;
  active: boolean;
  name: string;

  // Promotion requirements (see also schedules)
  orderTypeCodes: string[];
  customerGroupIds: string[];
  requiredCategoryCodes: string[];
  requiredProductCodes: string[];
  menuCodes: string[];
  requiredQty: number;
  requiredPrice: number;

  // Promotion reward specifications
  discountType: DiscountType;
  fixedAmount: number;
  percentTimes1000: number;
  categoryCodes: string[];
  productCodes: string[];
  childPromotionCodes: string[];
  maxUsesPerOrder: number | null;
  maxUsesPerRequirements: number | null;

  // For showing deals on the menu
  description?: string;
  image?: FileReference | null;

  // BUNDLE_PRICE only
  bundleComponents?: BundleComponent[] | null;
  targetPrice?: number | null;
}

// One slot of a bundle deal: any one of productCodes fills it, qty units are needed
export interface BundleComponent {
  id: string;
  label: string;
  productCodes: string[];
  qty: number;
}

export enum DiscountType {
  // REWARD_PRODUCT = "REWARD_PRODUCT",
  ORDER_DISCOUNT = "ORDER_DISCOUNT",
  LINE_DISCOUNT = "LINE_DISCOUNT",
  ROOT_ITEM_DISCOUNT = "ROOT_ITEM_DISCOUNT",
  CHILD_ITEM_DISCOUNT = "CHILD_ITEM_DISCOUNT",
  BUNDLE_PRICE = "BUNDLE_PRICE",
}

export interface PromotionSchedule extends SiteObject, BasePromotionSchedule {}

export interface BasePromotionSchedule {
  promotionCode: string;
  appliesFrom: string;
  appliesUntil: string | null;
  availability: Availability[];
  active: boolean;
  promoCodes: PromoCode[];
}

export interface PromoCode {
  code: string;
  uses: number | null;
  usesPerCustomer: number | null;
}
